module.exports = __webpack_public_path__ + "static/media/flavour_dropdown.ea4d65af.svg";